var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.89709 0.730993L13.4087 3.80249C13.5913 3.93545 13.7399 4.10952 13.8426 4.31061C13.9453 4.51169 13.9992 4.73414 14 4.95994V11.9748C14 12.1077 13.9472 12.2351 13.8532 12.3291C13.7593 12.4231 13.6318 12.4758 13.4989 12.4758C13.3661 12.4758 13.2386 12.4231 13.1446 12.3291C13.0507 12.2351 12.9979 12.1077 12.9979 11.9748V6.34788L11.4947 7.18465V7.22426L11.4782 7.1948L6.99954 9.70639L2.47039 7.17773L2.4687 7.18075L0.646743 6.15247L0.591626 6.11739C0.408466 5.98504 0.25933 5.8111 0.15648 5.60989C0.0536294 5.40867 0 5.18592 0 4.95994C0 4.73396 0.0536294 4.51121 0.15648 4.31C0.25933 4.10878 0.408466 3.93485 0.591626 3.80249L6.10329 0.730993C6.36641 0.547563 6.67944 0.449219 7.00019 0.449219C7.32093 0.449219 7.63397 0.547563 7.89709 0.730993ZM2.47561 8.32595V11.3067C2.47561 12.0933 3.60801 13.812 6.98516 13.812C10.3623 13.812 11.4947 12.0933 11.4947 11.3067V8.33205L7.00063 10.8523L2.47561 8.32595Z",
    fill: "#973BB7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHat);
export default __webpack_public_path__ + "static/media/hat.2cd85182e24ae67c3ab7a7698691c55e.svg";
export { ForwardRef as ReactComponent };